"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tertiary8 = exports.tertiary7 = exports.tertiary6 = exports.tertiary5 = exports.tertiary4 = exports.tertiary3 = exports.tertiary2 = exports.tertiary1 = exports.turquoise = exports.red = exports.orange = exports.green = exports.charcoal = exports.blue = exports.black = exports.amber = void 0;
const tslib_1 = require("tslib");
const amber_1 = tslib_1.__importDefault(require("./amber"));
exports.amber = amber_1.default;
const black_1 = tslib_1.__importDefault(require("./black"));
exports.black = black_1.default;
const blue_1 = tslib_1.__importDefault(require("./blue"));
exports.blue = blue_1.default;
const charcoal_1 = tslib_1.__importDefault(require("./charcoal"));
exports.charcoal = charcoal_1.default;
const green_1 = tslib_1.__importDefault(require("./green"));
exports.green = green_1.default;
const orange_1 = tslib_1.__importDefault(require("./orange"));
exports.orange = orange_1.default;
const red_1 = tslib_1.__importDefault(require("./red"));
exports.red = red_1.default;
const tertiary1_1 = tslib_1.__importDefault(require("./tertiary1"));
exports.tertiary1 = tertiary1_1.default;
const tertiary2_1 = tslib_1.__importDefault(require("./tertiary2"));
exports.tertiary2 = tertiary2_1.default;
const tertiary3_1 = tslib_1.__importDefault(require("./tertiary3"));
exports.tertiary3 = tertiary3_1.default;
const tertiary4_1 = tslib_1.__importDefault(require("./tertiary4"));
exports.tertiary4 = tertiary4_1.default;
const tertiary5_1 = tslib_1.__importDefault(require("./tertiary5"));
exports.tertiary5 = tertiary5_1.default;
const tertiary6_1 = tslib_1.__importDefault(require("./tertiary6"));
exports.tertiary6 = tertiary6_1.default;
const tertiary7_1 = tslib_1.__importDefault(require("./tertiary7"));
exports.tertiary7 = tertiary7_1.default;
const tertiary8_1 = tslib_1.__importDefault(require("./tertiary8"));
exports.tertiary8 = tertiary8_1.default;
const turquoise_1 = tslib_1.__importDefault(require("./turquoise"));
exports.turquoise = turquoise_1.default;
